module.exports = __webpack_public_path__ + "images/external_images/img/160x160/img8.jpg";